import React from "react";
import { Popover, MenuItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import VerticalAlignTopIcon from "@mui/icons-material/VerticalAlignTop";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import { TEAL } from "../constants";
 
export default function AddRowContextMenu({ anchorEl, onClose, onSelectAbove, onSelectBelow }) {
  return (
    <Popover
      open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={onClose}
      anchorOrigin={{ vertical: "center", horizontal: "right" }}
      transformOrigin={{ vertical: "center", horizontal: "left" }}
      PaperProps={{ elevation: 3, sx: { borderRadius: 2, minWidth: 190 } }}
    >
      <div style={{ padding: "6px 0" }}>
        <div style={{ padding: "6px 14px 4px", fontSize: 10, fontWeight: 600, color: "#bbb", textTransform: "uppercase", letterSpacing: "0.06em" }}>
          Tambah Baris
        </div>
        <MenuItem onClick={() => { onSelectAbove(); onClose(); }} sx={{ py: 1, px: 2, gap: 1.5, fontSize: 13 }}>
          <ListItemIcon sx={{ minWidth: "unset" }}>
            <VerticalAlignTopIcon fontSize="small" sx={{ color: TEAL }} />
          </ListItemIcon>
          <ListItemText primary="Di atas baris ini" primaryTypographyProps={{ fontSize: 13 }} />
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem onClick={() => { onSelectBelow(); onClose(); }} sx={{ py: 1, px: 2, gap: 1.5, fontSize: 13 }}>
          <ListItemIcon sx={{ minWidth: "unset" }}>
            <VerticalAlignBottomIcon fontSize="small" sx={{ color: TEAL }} />
          </ListItemIcon>
          <ListItemText primary="Di bawah baris ini" primaryTypographyProps={{ fontSize: 13 }} />
        </MenuItem>
      </div>
    </Popover>
  );
}